<template>
  <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
  <provide-state-triggered-by-slot-props v-slot="{ turnOff, turnOn, toggle, isOn }">
    <BasePopper v-click-outside="turnOff" :placement="placement" :display="isOn">
      <slot :turn-off="turnOff" :turn-on="turnOn" :toggle="toggle" :is-on="isOn" name="activation">
        <a :class="buttonClasses" class="pointer text-center" @click="toggle">
          <i :class="icon" class="zmdi" />
        </a>
      </slot>
      <template #popper>
        <div>
          <slot :turn-off="turnOff" :turn-on="turnOn" :toggle="toggle" :is-on="isOn" />
        </div>
      </template>
    </BasePopper>
  </provide-state-triggered-by-slot-props>
</template>

<script>
import BasePopper from '@/components/BasePopper.vue'

export default {
  name: 'BaseIconDropdown',
  components: {
    BasePopper,
  },
  props: {
    icon: {
      type: [Object, Array, String],
      default: 'zmdi-more-vert',
    },
    placement: {
      type: String,
      default: 'bottom',
    },
    buttonClasses: {
      type: [Object, Array, String],
      default: () => [],
    },
  },
}
</script>

<style scoped lang="scss">
// If you need to change the components styles please take into consideration this fact
// These styles are taken from .actions > li > a and .actions > li > a > i
// This is done since this components gets wrapped in two divs which stops said css from applying to our component
i {
  color: #adadad;
  font-size: 20px;
}

a {
  width: 30px;
  height: 30px;
  display: inline-block;
  padding-top: 5px;
  &:hover {
    i {
      color: #000;
    }
  }
}
</style>
